import { call, put, select } from 'redux-saga/effects'
import { RequestMethods } from 'utils/axios/methods'
import { Actions_report } from 'redux/modules/report/Actions'
import DateConverter from 'utils/helpers/date'
import { TState, TStoreTemplate } from 'redux/config/root-types'
import type { PayloadAction } from '@reduxjs/toolkit'
import TableFilterReduxAdapter from 'utils/helpers/table'
import { sagaAction_Error } from 'redux/sagas/actions/SagaAction_Error'
import { TFutureBooking, TPickUpParkingsFilters } from 'redux/modules/bookings/TReducer'
import { Actions_Bookings } from 'redux/modules/bookings/Actions'
import { IParking } from 'redux/modules/parkings/TReducer'

const { get } = RequestMethods()

export default function* SagaWorker_GetPickUpParkings({ payload }: PayloadAction<TPickUpParkingsFilters>) {
  yield put(Actions_report.store.showLoader())

  const {
    fromDate,
    toDate,
    southWesternLatitude,
    southWesternLongitude,
    northEasternLatitude,
    northEasternLongitude,
    types,
  } = payload || {}

  const formData = {
    fromDate: fromDate ? DateConverter.toISOString(DateConverter.toStartOfDay(fromDate)) : undefined,
    toDate: toDate ? DateConverter.toISOString(DateConverter.toEndOfDay(toDate)) : undefined,
    rentType: 'booking',
    southWesternLatitude: southWesternLatitude.toString(),
    southWesternLongitude: southWesternLongitude.toString(),
    northEasternLatitude: northEasternLatitude.toString(),
    northEasternLongitude: northEasternLongitude.toString(),
    types: types ? types : undefined,
  }

  try {
    const result: TStoreTemplate<{ parking: IParking[] }> = yield call(
      async () => await get<TStoreTemplate<{ parking: IParking[] }>>('/parking/webapp/booking', formData),
    )
    const responseInfo = result.data

    yield put(Actions_Bookings.store.savePickUpParkings(responseInfo?.parking || []))
  } catch (e) {
    yield call(() => sagaAction_Error(e))
  }

  yield put(Actions_report.store.hideLoader())
}
